/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M8 7V2M16 7V2M12 10.5L10 14.5H14L12 18.5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M3 13C3 11.1362 3 10.2044 3.30448 9.46927C3.71046 8.48915 4.48915 7.71046 5.46927 7.30448C6.20435 7 7.13623 7 9 7H15C16.8638 7 17.7956 7 18.5307 7.30448C19.5108 7.71046 20.2895 8.48915 20.6955 9.46927C21 10.2044 21 11.1362 21 13V13C21 15.7956 21 17.1935 20.5433 18.2961C19.9343 19.7663 18.7663 20.9343 17.2961 21.5433C16.1935 22 14.7956 22 12 22V22C9.20435 22 7.80653 22 6.7039 21.5433C5.23373 20.9343 4.06569 19.7663 3.45672 18.2961C3 17.1935 3 15.7956 3 13V13Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				opacity="0.12"
				d="M3 12C3 11.0707 3 10.606 3.07686 10.2196C3.39249 8.63288 4.63288 7.39249 6.21964 7.07686C6.60603 7 7.07069 7 8 7H16C16.9293 7 17.394 7 17.7804 7.07686C19.3671 7.39249 20.6075 8.63288 20.9231 10.2196C21 10.606 21 11.0707 21 12V13C21 13.9287 21 14.393 20.9615 14.7841C20.5874 18.5824 17.5824 21.5874 13.7841 21.9615C13.393 22 12.9287 22 12 22C11.0713 22 10.607 22 10.2159 21.9615C6.41765 21.5874 3.41261 18.5824 3.03852 14.7841C3 14.393 3 13.9287 3 13V12Z"
				fill="currentColor"
			/>
			<path
				d="M8 7V2M16 7V2M12 10.5L10 14.5H14L12 18.5M12 22V22C9.20435 22 7.80653 22 6.7039 21.5433C5.23373 20.9343 4.06569 19.7663 3.45672 18.2961C3 17.1935 3 15.7956 3 13V13C3 11.1362 3 10.2044 3.30448 9.46927C3.71046 8.48915 4.48915 7.71046 5.46927 7.30448C6.20435 7 7.13623 7 9 7H15C16.8638 7 17.7956 7 18.5307 7.30448C19.5108 7.71046 20.2895 8.48915 20.6955 9.46927C21 10.2044 21 11.1362 21 13V13C21 15.7956 21 17.1935 20.5433 18.2961C19.9343 19.7663 18.7663 20.9343 17.2961 21.5433C16.1935 22 14.7956 22 12 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M8.75 2C8.75 1.58579 8.41421 1.25 8 1.25C7.58579 1.25 7.25 1.58579 7.25 2V6.25559C5.8999 6.27389 5.0894 6.35205 4.43404 6.68597C3.68139 7.06947 3.06947 7.68139 2.68597 8.43404C2.25 9.28969 2.25 10.4098 2.25 12.65V13.15C2.25 16.5103 2.25 18.1905 2.90396 19.4739C3.4792 20.6029 4.39708 21.5208 5.52606 22.096C6.80953 22.75 8.48969 22.75 11.85 22.75H12.15C15.5103 22.75 17.1905 22.75 18.4739 22.096C19.6029 21.5208 20.5208 20.6029 21.096 19.4739C21.75 18.1905 21.75 16.5103 21.75 13.15V12.65C21.75 10.4098 21.75 9.28969 21.314 8.43404C20.9305 7.68139 20.3186 7.06947 19.566 6.68597C18.9106 6.35205 18.1001 6.27389 16.75 6.25559V2C16.75 1.58579 16.4142 1.25 16 1.25C15.5858 1.25 15.25 1.58579 15.25 2V6.25H8.75V2ZM12.3354 9.82918C12.7059 10.0144 12.8561 10.4649 12.6708 10.8354L11.2135 13.75H14C14.2599 13.75 14.5013 13.8846 14.638 14.1057C14.7746 14.3268 14.7871 14.6029 14.6708 14.8354L12.6708 18.8354C12.4856 19.2059 12.0351 19.3561 11.6646 19.1708C11.2941 18.9856 11.1439 18.5351 11.3292 18.1646L12.7865 15.25H10C9.74007 15.25 9.49867 15.1154 9.36201 14.8943C9.22536 14.6732 9.21293 14.3971 9.32918 14.1646L11.3292 10.1646C11.5144 9.79411 11.9649 9.64394 12.3354 9.82918Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M14 7H14.5H15C16.8638 7 17.7956 7 18.5307 7.30448C19.5108 7.71046 20.2895 8.48915 20.6955 9.46927C21 10.2044 21 11.1362 21 13V13C21 15.7956 21 17.1935 20.5433 18.2961C19.9343 19.7663 18.7663 20.9343 17.2961 21.5433C16.1935 22 14.7956 22 12 22V22C9.20435 22 7.80653 22 6.7039 21.5433C5.23373 20.9343 4.06569 19.7663 3.45672 18.2961C3 17.1935 3 15.7956 3 13V13C3 11.1362 3 10.2044 3.30448 9.46927C3.71046 8.48915 4.48915 7.71046 5.46927 7.30448C6.20435 7 7.13623 7 9 7H9.50003H10M8 7V2M16 7V2M12 10.5L10 14.5H14L12 18.5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M8 7V2M16 7V2M12 10.5L10 14.5H14L12 18.5M12 22V22C9.20435 22 7.80653 22 6.7039 21.5433C5.23373 20.9343 4.06569 19.7663 3.45672 18.2961C3 17.1935 3 15.7956 3 13V13C3 11.1362 3 10.2044 3.30448 9.46927C3.71046 8.48915 4.48915 7.71046 5.46927 7.30448C6.20435 7 7.13623 7 9 7H15C16.8638 7 17.7956 7 18.5307 7.30448C19.5108 7.71046 20.2895 8.48915 20.6955 9.46927C21 10.2044 21 11.1362 21 13V13C21 15.7956 21 17.1935 20.5433 18.2961C19.9343 19.7663 18.7663 20.9343 17.2961 21.5433C16.1935 22 14.7956 22 12 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M8.65 6.25C6.40979 6.25 5.28969 6.25 4.43404 6.68597C3.68139 7.06947 3.06947 7.68139 2.68597 8.43404C2.25 9.28969 2.25 10.4098 2.25 12.65V13.15C2.25 16.5103 2.25 18.1905 2.90396 19.4739C3.4792 20.6029 4.39708 21.5208 5.52606 22.096C6.80953 22.75 8.48969 22.75 11.85 22.75H12.15C15.5103 22.75 17.1905 22.75 18.4739 22.096C19.6029 21.5208 20.5208 20.6029 21.096 19.4739C21.75 18.1905 21.75 16.5103 21.75 13.15V12.65C21.75 10.4098 21.75 9.28969 21.314 8.43404C20.9305 7.68139 20.3186 7.06947 19.566 6.68597C18.7103 6.25 17.5902 6.25 15.35 6.25H8.65Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M8.75 2C8.75 1.58579 8.41421 1.25 8 1.25C7.58579 1.25 7.25 1.58579 7.25 2V5.5V6.25H8.75V5.5V2ZM16.75 2C16.75 1.58579 16.4142 1.25 16 1.25C15.5858 1.25 15.25 1.58579 15.25 2V5.5V6.25H16.75V5.5V2ZM12.6708 10.8354C12.8561 10.4649 12.7059 10.0144 12.3354 9.82918C11.9649 9.64394 11.5144 9.79411 11.3292 10.1646L9.32918 14.1646C9.21293 14.3971 9.22536 14.6732 9.36201 14.8943C9.49867 15.1154 9.74007 15.25 10 15.25H12.7865L11.3292 18.1646C11.1439 18.5351 11.2941 18.9856 11.6646 19.1708C12.0351 19.3561 12.4856 19.2059 12.6708 18.8354L14.6708 14.8354C14.7871 14.6029 14.7746 14.3268 14.638 14.1057C14.5013 13.8846 14.2599 13.75 14 13.75H11.2135L12.6708 10.8354Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
